import {TabState, TabStateDefaults} from 'Navigation';

export default class ContainerRelevantItemsTabState extends TabState {
  override defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Relevant Items',
      closeable: false,
      preferenceKey: 'container-relevant-items-tab',
    };
  }
}
